"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _color = _interopRequireDefault(require("./color"));
var _font = _interopRequireDefault(require("./font"));
var _font2 = _interopRequireDefault(require("../oneflare/font"));
var _default = exports.default = {
  backgroundColor: _color.default.white,
  bodyColor: '#626262',
  defaultLineHeight: '27px',
  defaultBold: 600,
  headingColor: _color.default.tertiary,
  headingFont: _font.default.primaryRegular,
  linkColor: _color.default.primary,
  linkFont: _font2.default.primaryRegular,
  padding: '32px 0',
  timestampColor: '#949494'
};